import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/save-win/tek_bg_01.webp";

function Idea() {
  return (
    <section
      className="save_idea p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto  order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/save-win/tek_img_01.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={570}
                height={628}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              The Idea Behind
              <span style={{ color: "#198463", display: "block" }}>
                Save & Win App
              </span>
            </h2>
            <p>
              The basic concept behind the creation of this type of software
              application is to provide users an opportunity to compare
              different products’ prices and features accessible in the
              mainstream markets.
            </p>
            <p>
              With this project, consumers could easily purchase products as per
              their desire and budget. Plus, this project enables users to find
              the best deals on the products they intend to buy and save money.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Idea;
